module.exports = __webpack_public_path__ + "7f42df5b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4k-1920.mp4
// module id = 1209
// module chunks = 1 3 4